import { ChangeDetectionStrategy, Component, ElementRef, effect, input, output, untracked, viewChild } from '@angular/core';

@Component({
  selector: 'app-amount-input',
  imports: [],
  template: `
    <input
      #amountInput
      type="text"
      class="amount-input"
      [placeholder]="placeholder()"
      (input)="handleInput($event.target)" />
  `,
  styleUrl: './amount-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmountInputComponent {
  readonly placeholder = input('$0 COP');
  // Al cambiar (boton 'Limpiar filtros') el campo se vacia aunque la vista se reutilice.
  readonly resetKey = input(0);

  // 'todas' cuando el campo queda vacío o sin dígitos, igual que el resto de filtros.
  readonly valueChange = output<number | 'todas'>();

  private readonly inputRef = viewChild.required<ElementRef<HTMLInputElement>>('amountInput');

  // El input no esta ligado a [value] (se formatea sobre el DOM al escribir), asi que el
  // reinicio tiene que limpiarlo de forma imperativa.
  private readonly resetOnKeyChange = effect(() => {
    this.resetKey();
    untracked(() => {
      this.inputRef().nativeElement.value = '';
    });
  });

  handleInput(target: EventTarget | null): void {
    const inputEl = target as HTMLInputElement;
    const raw = inputEl.value.replace('$', '').split('.').join('');

    if (!/[0-9]/.test(raw)) {
      inputEl.value = '';
      this.valueChange.emit('todas');
      return;
    }

    const numeric = parseInt(raw, 10);
    this.valueChange.emit(numeric);
    inputEl.value = this.formatCurrency(numeric);
  }

  private formatCurrency(value: number): string {
    return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
}
